// The track the Working Man piece is synced to.
export const YT_VIDEO_ID = "Izd-iRmYYGY";
export const TRACK_TITLE = "Robot Killed The Working Man";
export const TRACK_ARTIST = "Zach Bryan";

let ytApiPromise = null;
export const loadYouTubeAPI = () => {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (ytApiPromise) return ytApiPromise;
  ytApiPromise = new Promise((resolve) => {
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (prev) prev();
      resolve(window.YT);
    };
    const s = document.createElement("script");
    s.src = "https://www.youtube.com/iframe_api";
    s.async = true;
    document.head.appendChild(s);
  });
  return ytApiPromise;
};
